<template>
  <div class="relative">
    <swiper class="swiper" :options="swiperOptions">
      <swiper-slide class="sm-h600">
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="@/assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="@/assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="@/assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="@/assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div class="ml-auto lg:pt-0 md:pt-0 pt-20 lg:px-0 md:px-0 px-6">
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
              >
                Make a Wish, Change a Life
              </p>
              <p
                class="fsize20px sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 font-f text-primary"
              >
                This Joy of Giving Week, support our Wish Tree, and help
                caregivers across India. Choose a wish to fulfil and make a
                meaningful impact
                <!-- <i>
                  Know about our programs and Initiatives and support us to
                  reach are goals
                </i> -->
              </p>
            </div>
            <div class="flex gap-4 pt-5 lg:pl-0 md:pl-0 pl-5">
              <b-button
                variant="primary"
                class="lg:my-0 md:my-0 my-4 fsize20 sm-fsize14"
              >
                <a
                  href="#wishTree"
                  v-smooth-scroll="{ duration: 1000, offset: -10 }"
                  class="js-anchor-link anchor_white"
                  >Explore the Wish Tree
                </a>
              </b-button>
            </div>
          </div>

          <div class="lg:w-1/2 md:w-1/2 w-full relative">
            <img
              src="@/assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per h-450px sm-h-250px bg-white"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Support%20in%20creating%20digital%20directory.png"
              class="lg:w-3/4 custborderradius absolute min-top8rem mt-8 lg:p-0 md:p-0 p-4"
              alt=""
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="@/assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="@/assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="@/assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="relative h-95per flex justify-end">
          <img
            src="@/assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px bg-white"
          />
        </div>

        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32"
        >
          <!-- <img
            src="@/assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <div class="ml-auto lg:pt-0 md:pt-0 pt-2 lg:px-0 md:px-0 px-6">
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
              >
                Donate
              </p>
              <p
                class="fsize20px sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 font-f text-primary"
              >
                <i>
                  " There comes a point when we need to stop just pulling people
                  out of the river. We need to go upstream and find out why
                  they're falling in "<br />
                </i>
              </p>
              <p
                class="fsize20px sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 font-f text-gray"
              >
                <i> -Desmond Tutu</i>
              </p>
            </div>
            <div class="pt-5 lg:pl-0 md:pl-0 pl-5">
              <a href="https://pages.razorpay.com/caregiversaathi-donation">
                <b-button
                  variant="primary"
                  class="lg:my-0 fsize20 sm-fsize14 md:my-0 my-4"
                  >Donate Now</b-button
                >
              </a>
            </div>
          </div>

          <div class="lg:w-1/2 md:w-1/2 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/JoinUs/Contribution-Donate-Banner.jpeg"
              class="custborderradius lg:p-0 md:p-0 p-4"
              alt=""
            />
            <!-- <img
            src="@/assets/images/swiper-img/swpr-insi-blog.svg"
            class="w-full absolute top6rem h-screen md:block lg:block hidden"
            alt=""
          /> -->
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="sm-h600">
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="@/assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img src="@/assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="@/assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="@/assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div class="ml-auto lg:pt-0 md:pt-0 pt-20 lg:px-0 md:px-0 px-6">
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
              >
                Program and Initiatives
              </p>
              <p
                class="fsize20px sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 font-f text-primary"
              >
                <i>
                  Know about our programs and Initiatives and support us to
                  reach are goals
                </i>
              </p>
            </div>
            <div class="flex gap-4 pt-5 lg:pl-0 md:pl-0 pl-5">
              <b-button
                variant="primary"
                class="lg:my-0 md:my-0 my-4 fsize20 sm-fsize14"
                @click="handleScroll()"
                >Know More</b-button
              >

              <!-- <a href="">
                <b-button
                  variant="primary"
                  class="lg:my-0 md:my-0 my-4 fsize20 sm-fsize14"
                  >Donate Later</b-button
                >
              </a> -->
            </div>
          </div>

          <div class="lg:w-1/2 md:w-1/2 w-full relative">
            <img
              src="@/assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per h-450px sm-h-250px bg-white"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Donation%20page%20-%20banner2.jpg"
              class="lg:w-3/4 custborderradius absolute min-top8rem mt-8 lg:p-0 md:p-0 p-4"
              alt=""
            />
            <!-- <img
            src="@/assets/images/swiper-img/swpr-insi-blog.svg"
            class="w-full absolute top6rem h-screen md:block lg:block hidden"
            alt=""
          /> -->
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <div
        class="swiper-pagination cust-posi dot-shift top97"
        slot="pagination"
      ></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 12000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      editModal: false,
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleScroll() {
      const el = document.getElementById("HealthcareDiv");
      // console.log(el, "el");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>
<style>
.h-450px {
  height: 450px;
}

@media (max-width: 640px) {
  .sm-h-250px {
    height: 250px;
  }
}
.anchor_white:hover {
  color: #fff !important;
}
</style>
